module.exports = __webpack_public_path__ + "static/media/noteams.9bad81c1.png";